import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import './TermsOfService.css';

function TermsOfService() {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Terms of Service - DocuHounds';
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = 'Terms of Service for DocuHounds - AI-powered academic assistant. Learn about user rights, responsibilities, and platform usage policies.';

    // Load markdown content
    fetch('/legal/terms-of-service.md')
      .then(res => res.text())
      .then(text => {
        setContent(text);
        setLoading(false);
      })
      .catch(err => {
        console.error('Failed to load terms of service:', err);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className="termsPage">
        <div className="termsContainer">
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="termsPage">
      <header className="termsHero">
        <h1 className="termsTitle">Terms of Service</h1>
        <p className="termsUpdated">Last updated: January 5, 2026</p>
        <p className="termsSubtitle">
          These terms govern your use of DocuHounds. By using our platform, you agree to these terms.
        </p>
      </header>

      <div className="termsContainer">
        <div className="card sectionCard">
          <ReactMarkdown
            components={{
              h2: ({ node, children, ...props }) => {
                const id = children?.toString().toLowerCase().replace(/[^\\w]+/g, '-');
                return <h2 className="sectionTitle" id={id} {...props}>{children}</h2>;
              },
              h3: ({ node, children, ...props }) => <h3 className="subTitle" {...props}>{children}</h3>,
              ul: ({ node, ...props }) => <ul className="bullets" {...props} />,
              blockquote: ({ node, ...props }) => (
                <div className="box boxInfo" {...props} />
              ),
            }}
          >
            {content}
          </ReactMarkdown>
        </div>
      </div>
    </div>
  );
}

export default TermsOfService;
